import { SoftwareComponentDto } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  availableApps?: number[];
}
export default function SoftwareComponentsInput({ availableApps, ...props }: Props) {
  const [data, setData] = React.useState<SoftwareComponentDto[]>([]);

  React.useEffect(() => {
    getData();
  }, [availableApps]);

  const getData = () => {
    apiSdk.SoftwareComponentService.getActiveSoftwareComponents({
      availableApps: availableApps?.length ? (availableApps as any) : undefined,
    }).then(res => {
      setData(res || []);
    });
  };
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.name}
          </Select.Option>
        );
      })}
    </Select>
  );
}
